<script>
export default {
  props: {
    pointers: Array,
    steps: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    subdomain() {
      return this.cname.value.split('.').slice(0, -2).join('.')
    },
    domain() {
      return this.cname.value.split('.').slice(-2).join('.')
    },
    cname() {
      return this.pointers.find(({ type }) => type === 'CNAME')
    },
    a() {
      return this.pointers.find(({ type }) => type === 'A')
    },
  },
}
</script>

<template>
  <div class="dns-pointers mt-2">
    <strong>{{ $t('pointerStatus') }}</strong>

    <table class="table--border table--padding">
      <thead>
        <th>{{ $t('pointerType') }}</th>
        <th>{{ $t('name') }}</th>
        <th>{{ $t('value') }}</th>
      </thead>
      <tbody>
        <tr v-for="pointer in pointers" :key="pointer.value">
          <td
            :class="[
              'dns-pointers__type',
              {
                'dns-pointers__type--valid': steps[pointer.type],
              },
            ]"
          >
            <Icon :icon="`fa-solid:circle`" />
            <span class="ml-1">{{ pointer.type }}</span>
          </td>
          <td>{{ pointer.value }}</td>
          <td>{{ pointer.target }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss">
.dns-pointers {
  &__type {
    display: flex;
    align-items: center;
    svg {
      height: 13px;
      color: var(--warning);
    }
    &--valid {
      svg {
        color: var(--success);
      }
    }
  }
}
</style>
